import tippy, { hideAll } from "tippy.js";

const selectors: Record<"item" | "marker" | "popup", string> = {
  item: "[data-popup-item]",
  marker: "[data-marker]",
  popup: "[data-popup]",
};

const classes: Record<"active", string> = {
  active: "active",
};

const elements: Record<"items", NodeListOf<HTMLElement> | null> = {
  items: null,
};

const init = () => {
  elements.items = document.querySelectorAll(selectors.item);

  Array.from(elements.items).forEach((item) => {
    const popup = item.querySelector(selectors.popup) as HTMLElement;
    const marker = item.querySelector(selectors.marker) as HTMLElement;

    if (!popup) return null;

    tippy(marker, {
      content: popup.innerHTML,
      allowHTML: true,
      trigger: "click",
      placement: "bottom",
      animation: "scale",
      interactive: true,
      maxWidth: 500,
      onShow(instance) {
        marker.classList.add(classes.active);
        hideAll({ exclude: instance });
      },
      onHide() {
        marker.classList.remove(classes.active);
      },
    });
  });
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    init();
  },
  { once: true }
);
